import {
  GridComparatorFn,
  gridStringOrNumberComparator,
} from "@mui/x-data-grid";
import moment from "moment";

// Sort values by bed as a secondary sort
export const BedSubSortComparator: GridComparatorFn = (
  v1,
  v2,
  param1,
  param2
) => {
  // initially, use the default grid sorting
  const comparatorResult = gridStringOrNumberComparator(v1, v2, param1, param2);

  // if they don't match, we can return
  if (comparatorResult !== 0) {
    return comparatorResult;
  }

  // otherwise, we now need to sort them by bed
  const v1Row = param1.api.getRow(param1.id);
  const v2Row = param2.api.getRow(param2.id);

  return gridStringOrNumberComparator(
    v1Row.current_bed,
    v2Row.current_bed,
    param1,
    param2
  );
};

export const EDDBedSubSortComparator: GridComparatorFn = (
  v1,
  v2,
  param1,
  param2
) => {
  if (v1.eddValue === null || v1.eddValue === undefined) return -1;
  if (v2.eddValue === null || v2.eddValue === undefined) return 1;

  const edd = moment(v1.eddValue);
  const edd2 = moment(v2.eddValue);

  const dateDiff = edd.diff(edd2);
  if (dateDiff !== 0) {
    return dateDiff;
  }

  // otherwise, we now need to sort them by bed
  const v1Row = param1.api.getRow(param1.id);
  const v2Row = param2.api.getRow(param2.id);

  return gridStringOrNumberComparator(
    v1Row.current_bed,
    v2Row.current_bed,
    param1,
    param2
  );
};

export const CareTeamSortComparator: GridComparatorFn = (
  v1,
  v2,
  param1,
  param2
) => {
  const comparatorResult = gridStringOrNumberComparator(
    v1.attending_provider,
    v2.attending_provider,
    param1,
    param2
  );
  if (comparatorResult !== 0) {
    return comparatorResult;
  }

  const v1Row = param1.api.getRow(param1.id);
  const v2Row = param2.api.getRow(param2.id);

  return gridStringOrNumberComparator(
    v1Row.current_bed,
    v2Row.current_bed,
    param1,
    param2
  );
};

export const LocationSortComparator: GridComparatorFn = (
  v1,
  v2,
  param1,
  param2
) => {
  return gridStringOrNumberComparator(
    v1.current_bed,
    v2.current_bed,
    param1,
    param2
  );
};
